module.exports = __webpack_public_path__ + "assets/img/29c6-cu.svg";